;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();import { useCanaryClient } from '@qogita/deprecated-canary-client/provider'
import { useQuery } from '@tanstack/react-query'
import { getSaleWithHiddenOffersQueries } from 'src/deprecated/api/hidden-offers-queries'

export function useGetSaleWithHiddenOffersList() {
  const canaryClient = useCanaryClient()
  const hiddenProductsQueries = getSaleWithHiddenOffersQueries(canaryClient)

  const { data, isLoading } = useQuery({
    ...hiddenProductsQueries.list(),
  })

  return {
    data,
    isLoading,
  }
}
